<app-panel-body>
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
        <p class="text-base font-semibold text-primary-text">{{ 'payment-importance.lead' | transloco }}</p>
        @for (key of bodyKeys; track key) {
          <p class="text-sm text-primary-text">{{ key | transloco }}</p>
        }
      </app-content-container>
    </div>

    <div class="flex shrink-0 gap-3 border-t border-primary-border px-4 py-3">
      <app-button variant="outline" (clicked)="close()">
        {{ 'payment-importance.close' | transloco }}
      </app-button>
    </div>
  </div>
</app-panel-body>
